import Vue from 'vue'

const requireModule = require.context('.', false, /^((?!index|\.unit\.).)*\.js$/)

requireModule.keys().forEach((fileName) => {
    if (fileName === './index.js') return
    const name = fileName.replace(/^.*(\\|\/|:)/, '').split('.')[0]
    Vue.filter(name, requireModule(fileName).default)
})
